export default __webpack_public_path__ + "static/media/08.c7204707.jpg";